"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Snippet = Snippet;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _InternalHighlight = require("./InternalHighlight");

var _cx = require("./lib/cx");

var _excluded = ["classNames"];

function Snippet(_ref) {
  var _ref$classNames = _ref.classNames,
      classNames = _ref$classNames === void 0 ? {} : _ref$classNames,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_InternalHighlight.InternalHighlight, (0, _extends2.default)({
    classNames: {
      root: (0, _cx.cx)('ais-Snippet', classNames.root),
      highlighted: (0, _cx.cx)('ais-Snippet-highlighted', classNames.highlighted),
      nonHighlighted: (0, _cx.cx)('ais-Snippet-nonHighlighted', classNames.nonHighlighted),
      separator: (0, _cx.cx)('ais-Snippet-separator', classNames.separator)
    }
  }, props));
}